import type { IconData } from '@stacksjs/iconify-core'

export const charging: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M44.788 21C43.332 10.823 34.58 3 24 3S4.67 10.823 3.213 21M27 44.787a21 21 0 0 0 4.798-1.282M21 44.787a20.8 20.8 0 0 1-4.829-1.295M44.788 27a21 21 0 0 1-1.283 4.797M3.213 27c.239 1.67.674 3.278 1.282 4.797m6.515 8.704a21 21 0 0 1-3.531-3.536m33.043 0a21 21 0 0 1-3.558 3.557\"/><path d=\"M20.746 26.794a98 98 0 0 1-6.657-1.038c-1.442-.28-1.987-1.956-1.005-3.049c2.512-2.797 7.006-7.605 11.87-11.883c1.29-1.134 3.235-.14 3.116 1.574c-.25 3.597-.543 6.527-.815 8.808c2.75.336 5.009.72 6.656 1.038c1.443.28 1.987 1.956 1.006 3.049c-2.512 2.796-7.006 7.605-11.87 11.883c-1.29 1.134-3.235.14-3.116-1.574c.25-3.597.542-6.527.815-8.808\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default charging
